import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { defaults, Pie } from 'react-chartjs-2';
import Color from 'color';

//import logo from '../../assets/images/logos/Logo-Color@2x.png';
//import logo from '../../assets/images/logos/Bechtel-Logo-650.png';
import logo from '../../assets/images/logos/Westinghouse-Icon.png';

import { toTitleCase, colorForCategory, getWestinghouseCategoryComponents, getScoreClassificationInOrderedGroupScores } from '../../util';
import { getOrderedUserStrengthsFromAllScores, getUserDataFromAllUsers } from '../../util/data';
import { introForPlanYourCareer, introForPlayToYourStrengths, descriptionForPlayToStrengthsTalent, descriptionForPlayToStrengthsCategory, descriptionForTalentCategoryStrength, descriptionForTalentCategoryWeakness, descriptionForTalent, descriptionForTalentCategory, descriptionForCompetency, descriptionForPlayToStrengthsTalentCategory } from '../../util/westinghouseDescriptions';
import { iconForTalentCategory } from '../../util/icons';

let PAGE_OFFSET = 4;

const usersWithCompetitiveAdvantages = {
  "0xFvWFH15eIb1urWVZIt": true,
  "11P0KMhJIudDGn13sMPh": true,
  "20FdpkmEkH7AZVvkll5U": true,
  "2tVH0UHKVlfdD571CruT": true,
  "33wmynKcBMkJ5pQOmty1": true,
  "3E6SdMf9nNb1qW6m0XNc": true,
  "3eEmgw0LzQmLEVhF4wCa": false,
  "4I2cUDtJ89FfSfKlB4MF": false,
  "60cA5chknggisbCqrD2A": false,
  "6XYL5t931d4LeD889vvt": false,
  "6cxDkoMcmjItrEB0wJoH": true,
  "7HDhFcZDR6UYO5gKQM45": true,
  "7aRPwwTSWwaAr7zAGugn": true,
  "8YVifvs6kSpLy6RSAbc0": true,
  "8lac6XgSpB0mnFnM7oB8": true,
  "9EOr7P5767Mwqg3zO4lO": true,
  "9MSPm1XBnEJFTOXXvzdU": true,
  "AZpQ0li6qUysmKueLJzL": true,
  "AcoZmstyC3iOXRUL9xD2": false,
  "BPekIzExD23EkbgBO1QC": true,
  "D2lFzwvKZkvliaWLSgKY": true,
  "DLNcDb9zR2QZoV9pkfdU": true,
  "DNojYBbMMcrtrVz0e9Ks": false,
  "DP1KTYFV7qPyFEk9c0EO": true,
  "EsDHElR8OcbcBbUiCY1v": false,
  "EtcYNPXK7ZxjgXJFK35r": true,
  "Ewtxhvber4LsMlB2UrED": true,
  "FyDpnE1EW2tA0VNH6Drf": true,
  "GdcVrZIH1fjx5r1Q22ft": true,
  "H0FYnmC8rmUrk1t8Cy1i": false,
  "HIakn9KzAe3eJSHgEIBK": true,
  "HucQRE21watM4guOzXKg": false,
  "JIIeF8sWTqtxIGooGwFA": true,
  "JQ8vQ5WHQtl0qoB0TGyr": true,
  "JcKVNGJeoJxVxj8rGfMH": true,
  "LaAjMLIoiYURqyZhLt8R": false,
  "LgChIBguMU4MDtOFL6bG": false,
  "M6qzg504GPwnFMnuuFAu": false,
  "MhfjqpILOUf7adRzYGIw": false,
  "Mw605X8KkxrmCLZZSALl": false,
  "Nrur4KLj5oAcWoyZ8wpq": false,
  "Ob6PMUegIhv1Rmt5I5kr": true,
  "PERE9m06CMXVrGv4x9FW": false,
  "PZPvcCxEE2H0hG23dmkR": false,
  "QAfMQLIzBqFxsOAYNfG1": true,
  "QFdX7NTXyxU2fPD19Yf2": false,
  "QJYyHlA8cs3MxjXuZ2mV": true,
  "RSMJTQEpxox9rD8prK1i": true,
  "RUCH4Ru5PatM7xjPldKp": false,
  "RhDfrhJvCGHwV0lpCRhU": false,
  "SEnf3QXC32VI9eaHyi2W": true,
  "SUuJJpgn6dASiXAtrHjL": false,
  "TC26mDYPmLUVAjAXlpMA": false,
  "TK4ITmeNTkrG8JpvSFsX": true,
  "TW4LNyWchBDVdx5ZuGRY": true,
  "TpW6x7UgIFK4BwRIyjaN": true,
  "UjzlBMWkPDhi0YtjpFhj": true,
  "VFgLarWlhLIFZj9xkE4l": false,
  "VGCP1WgJ7iCJzZTpseo3": true,
  "VUFVRnSWnSsgJKsGZq0O": true,
  "VW49d3yAjLOp6LBjkInA": true,
  "WBUATGfMeGsTTeHur9yL": false,
  "WQ7sXvLOurr6d4LWLAGD": false,
  "XNjUCVtxjCIpPhRIQ6xu": true,
  "XzVtYCps5Y2uvTSLfBAc": false,
  "YQtB7w39Y4ADQo08zH1I": false,
  "ZMTWZXn1xvwFFIJiEphE": false,
  "a5mFios1d3fv8VkRukaF": true,
  "bBaYMcKApyzfvHtZcmoK": false,
  "bK28MEIu9KWniaKNBDnt": false,
  "bmlKAV9u8r8DFlRVr2Dd": true,
  "bsz5pUUhXwewoZlE6eeB": false,
  "cANNN9c3vMyiMUr0VcRX": true,
  "cGxIRFwMqgy4KspEseGH": false,
  "cTutliQeviVZ4MvjYhMk": true,
  "cg8sNoO8y92wLaUqWqol": true,
  "d1RmLx3yEHekphPolTg5": true,
  "d4vRNb35L4PH6HEV29ho": true,
  "dbxrd6SwAMyeZONyMxUo": false,
  "deuhtOi1vzAedZSibv4l": true,
  "fAiN32YaH87pZyuiLv1p": true,
  "g7DSGVuQun1nMWH5Mvwk": true,
  "ghR2REEtQDsSuTJ7K2Fo": true,
  "i0gV5MFKE269al3nRiH4": false,
  "iDhiLbpTkHpJ3Zh3DerG": true,
  "j3Mgcmt0BNymFbAKBf89": true,
  "jTSCsBAUENnJhdQGbDai": false,
  "jn0qJxaLqpJ5jt6QMzws": true,
  "k896pKuOWAmTj1QyTJJy": false,
  "kPOVrSisGVDgXpelB0Bz": false,
  "kRfZxhEEzsa4gYG3rvgf": false,
  "lIWIbOpq3EX4Fw38CjV2": true,
  "ldejDjs5Tu5gi6b62l2v": false,
  "lso2Zfgpc1SzwNFrbEDA": true,
  "nDOK98euJQMZqWx5Qd7j": true,
  "oD579edxOpdLv9eB76Hw": true,
  "oVGDqa8kZvlRhiCjMTlW": true,
  "otyCj53ngG5fWTLNc4nm": false,
  "pHUKYfubSHrXZ7tpmrvN": true,
  "phwFnObsQ0nRm71skpDH": true,
  "pvhDoEMWVUxoOO88O6Bz": true,
  "qA1YOAlliVMdNqs8dnlS": true,
  "qNSGfrZG6nhNvheK6owL": true,
  "qUVvjskUAldpfs1OrTa4": true,
  "qilEcFcJXdY4sc0ZjXBD": true,
  "rIn2ccQ5lybKXVBhoIUH": true,
  "rgkNEz7erSa997C0wihh": true,
  "sFcPwa2yZFZ1iuiX56sX": true,
  "voLdGkm2jdjzgTcDwmPn": false,
  "w9AQwRSFCuhXENOdHQSB": true,
  "xaxH04MQ8Pzylgbj59bh": false,
  "y4zyzgth8UejrJLi43fq": true,
  "y7ufdPqRmGqboQEaQXfU": true,
  "zq5sUXSAkpR1i5fHGzG0": false
}

//const LOGO_WIDTH = "150";
//const LOGO_HEIGHT = "40";
const LOGO_WIDTH = "50";
const LOGO_HEIGHT = "50";

// Disable animating charts by default.
defaults.pie.animation.animateRotate = false;
defaults.pie.animation.animateScale = false;
defaults.global.tooltips.enabled = false;
//defaults.global.elements.arc.borderWidth = 0;
defaults.global.elements.arc.backgroundColor = 'rgba(0,0,0,.1)';

const TALENT_CATEGORIES=[{
  name: 'Motivation',
  id: 'motivation'
},{
  name: 'Interaction',
  id: 'interaction'
},{
  name: 'Execution',
  id: 'execution'
},{
  name: 'Cognition',
  id: 'cognition'
}];

class WestinghouseReport extends Component {

  state = {
    ProfileID: null
  }

  componentWillMount(){
    const { match: { params } } = this.props;

    this.setState({
      ProfileID: params.ProfileID
    });

    //pages offset by one less if no CA report
    if(usersWithCompetitiveAdvantages[params.ProfileID]){
      PAGE_OFFSET = 4;
    }
    else{
      PAGE_OFFSET = 3;
    }
  }
  componentDidMount(){
    console.log('westinghouse report props: ', this.props);
  }

  renderLoadingMessage(){
    return <p>Loading...</p>;
  }

  dataForProfile(){

    const ProfileID = this.state.ProfileID;

    console.log(`data for profile ${ProfileID} calculating...`);

    const userData = _.find(this.props.users, {_id: ProfileID} );

    console.log('userData: ', userData);

    if(!userData){
      return null;
    }

    const strengths = getOrderedUserStrengthsFromAllScores(userData);

    console.log('strengths: ', strengths);

    if(!strengths){
      return null;
    }

    return {
      user: userData,
      strengths: strengths,
    }
  }

  componentWillReceiveProps(nextProps){
    console.log('westinghouse report page nextProps: ', nextProps);
  }

  renderPieChart(chartData){
    return <Pie legend={{display:false}} ref='chart' options={{maintainAspectRatio:false}} data={chartData} />
  }

  orderedTalentCategories(){
    const strengthScores = this.dataForProfile().strengths;

    return strengthScores;
  }

  chartDataForCategory(category = 'all'){

    if(category === 'all'){
      const orderedTalentCategories = this.orderedTalentCategories();

      return {
        datasets: [{
          data: _.map(orderedTalentCategories, 'percent'),
          backgroundColor: _.map(_.map(orderedTalentCategories, 'id'), colorForCategory)
        }]
      }
    }
    else{
      const categoryColor = Color(colorForCategory(category.id));

      return {
        datasets: [{
          data: _.map(category.talents, 'percent'),
          backgroundColor: [categoryColor.rgb().string(), categoryColor.fade(.2).rgb().string(), categoryColor.fade(.4).rgb().string(), categoryColor.fade(.6).rgb().string(), categoryColor.fade(.8).rgb().string()]
        }]
      }
    }
  }

  renderStrengthsScores(){
    const categories = this.orderedTalentCategories();

    return(
      <div className="strengths-scores tall">
        <div className="pie">
          <div className="chart-container">
            {this.renderPieChart(this.chartDataForCategory('all'))}
          </div>
        </div>

        {_.map(categories, category => {

          const categoryScoreClassification = getScoreClassificationInOrderedGroupScores(category.percent, _.map(categories, 'percent'));

          return (
            <div key={category.id} className={`strength ${category.id}`}>
              <div className="name">{category.name}</div>
              <div className="percent" style={{color: colorForCategory(category.id)}}>{Math.round(category.percent)}%</div>
              {categoryScoreClassification === 'high' &&
                <div className="strong-indicator" style={{backgroundColor: colorForCategory(category.id)}}>Strong Category</div>
              }
              {categoryScoreClassification === 'low' &&
                <div className="strong-indicator" style={{backgroundColor: colorForCategory(category.id)}}>Weak Category</div>
              }
            </div>
          );
        })}
      </div>
    )
  }

  renderScoresForCategory(category){

    //console.log('renderScoresForCategory: ', category);

    return(
      <div className={`strengths-scores ${category.talents.length === 3 ? 'three-wide' : ''}${category.talents.length === 5 ? 'five-wide' : ''} tall`}>
        <div className="pie">
          <div className="chart-container">
            {this.renderPieChart(this.chartDataForCategory(category))}
          </div>
        </div>

        {_.map(category.talents, (talent, index) => {

          const talentScoreClassification = getScoreClassificationInOrderedGroupScores(talent.percent, _.map(category.talents, 'percent'));

          return (
            <div key={talent.name} className={`strength ${talent.name}`}>
              <div className="name">{talent.name}</div>
              <div className="percent">{Math.round(talent.percent)}%</div>
                {talentScoreClassification === 'high' &&
                  <div className="strong-indicator" style={{backgroundColor: colorForCategory(category.id)}}>Strong Talent</div>
                }
                {talentScoreClassification === 'low' &&
                  <div className="strong-indicator" style={{backgroundColor: colorForCategory(category.id)}}>Weak Talent</div>
                }
            </div>
          );
        })}
      </div>
    )
  }

  renderSingleScorePie(percentage, color){
    const dataForPie = {
      datasets: [{
        data: [percentage, (100 - percentage)],
        backgroundColor: [color,'rgba(0,0,0,.1)'],
      }]
    }

    return <Pie legend={{display:false}} ref='chart' options={{maintainAspectRatio:false}} data={dataForPie} />
  }

  getScoreLabel(score, isCategory, scoreClassification = false){

    const roundedScore = Math.round(score);

    if(!scoreClassification){
      return roundedScore + '%';
    }
    else if(scoreClassification === 'high'){
      return roundedScore + '% - Strong ' + (isCategory ? 'category' : 'talent');
    }
    else if(scoreClassification === 'low'){
      return roundedScore + '% - Weak ' + (isCategory ? 'category' : 'talent');
    }
    else{
      return roundedScore + '%';
    }
  }

  renderTalentCategories(){

    const categories = this.orderedTalentCategories();
    const dataForProfile = this.dataForProfile();

    if(!dataForProfile){
      return null;
    }

    return(
      <div className="talents">
        {_.map(categories, (category, index) => {

          const categoryScoreClassification = getScoreClassificationInOrderedGroupScores(category.percent, _.map(categories, 'percent'));
          const categoryTalents = getWestinghouseCategoryComponents(category.id, dataForProfile.user["FiveRoles"]);
          const categoryTalentsAsString = _.reduce(categoryTalents, function(memo, talent, index){
            if(index > 0){
              return memo + ', ' + toTitleCase(talent);
            }
            else{
              return toTitleCase(talent);
            }
          }, '');

          return (
            <div key={'category-definition-' + category.id} className="talent">
              <div className="talent-summary">
                <div className="talent-name">{category.name}</div>
                <div className="chart-container">
                  {this.renderSingleScorePie(category.percent, colorForCategory(category.id))}
                </div>
                <div className="percent" style={{color: colorForCategory(category.id)}}>{this.getScoreLabel(category.percent, true, categoryScoreClassification)}</div>
              </div>
              <div className="talent-info">
                <p>{descriptionForTalentCategory(category.id)}</p>
                {categoryScoreClassification === 'high' &&
                  <p>{descriptionForTalentCategoryStrength(category.id)}</p>
                }
                {categoryScoreClassification === 'low' &&
                  <p>{descriptionForTalentCategoryWeakness(category.id)}</p>
                }
                <p className="competency">&gt; &nbsp;Predictive {category.name} Talents: {categoryTalentsAsString}</p>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  renderTalentsForCategory(category){
    return(
      <div className="talents">
        {_.map(category.talents, talent => {

          const talentScoreClassification = getScoreClassificationInOrderedGroupScores(talent.percent, _.map(category.talents, 'percent'));

          return (
            <div key={'category-definition-' + talent.id} className="talent">
              <div className="talent-summary">
                <div className="talent-name">{talent.name}</div>
                <div className="chart-container">
                  {this.renderSingleScorePie(talent.percent, colorForCategory(category.id))}
                </div>
                <div className="percent" style={{color: colorForCategory(category.id)}}>{this.getScoreLabel(talent.percent, false, talentScoreClassification)}</div>
              </div>
              <div className="talent-info">
                <p>{descriptionForTalent(talent.id)}</p>
                <p className="competency">&gt; &nbsp;Competency: {descriptionForCompetency(talent.id)}</p>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  renderFooterForPage(pageNumber){
    return (
      <div className="page-footer">
        {this.renderCopyright()}
        {this.renderPageNumber(pageNumber)}
        {this.renderPreparedForUser()}
      </div>
    )
  }

  renderCopyright(){
    return (
      <div className="copyright">&copy; 2019 Velocity.Win, LLC</div>
    )
  }

  renderPreparedForUser(){
    const dataForProfile = this.dataForProfile();

    const {FirstName, LastName} = dataForProfile.user;

    return (
      <div className="prepared-for">Prepared for {FirstName} {LastName}&nbsp;&middot;&nbsp;</div>
    )
  }

  renderPageNumber(number){
    return (
      <div className="page-marker">Page {number}</div>
    )
  }

  renderCategoryPage(category, index){
    return (
      <div key={'page-' + category.id} className="report-know-your-strengths report-page">
        <img className="report-logo" width={LOGO_WIDTH} height={LOGO_HEIGHT} src={logo} />
        <h2>{category.name} Talents</h2>
        {this.renderScoresForCategory(category)}
        {this.renderTalentsForCategory(category)}
        {this.renderFooterForPage(index + 2 + PAGE_OFFSET)}
      </div>
    )
  }

  renderPlayToYourStrengthsReport(dataForProfile){

    const orderedTalentCategories = this.orderedTalentCategories();

    return (
      <template>
        <div className="page report-export">
          <div className="report-play-to-your-strengths report-page">
            <img className="report-logo" width={LOGO_WIDTH} height={LOGO_HEIGHT} src={logo} />
            <h1>Play To Your Strengths<br/><span className="prepared-for" style={{textTransform: 'capitalize'}}>{dataForProfile.user.FirstName + ' ' + dataForProfile.user.LastName}</span></h1>
            <div className="report-section" style={{paddingTop: '0px'}} dangerouslySetInnerHTML={{__html: introForPlanYourCareer()}}></div>
            <div className="report-section full-width-with-icon">
              <div className="section-icon">{iconForTalentCategory(orderedTalentCategories[0].id)}</div>
              <div className="section-title">Your leading VELOCITY.win category: {orderedTalentCategories[0].name}</div>
              <div className="section-content large-font" dangerouslySetInnerHTML={{__html: descriptionForPlayToStrengthsTalentCategory(orderedTalentCategories[0].id)}}></div>
            </div>
            <div className="report-section no-bottom-border">
              <p>The next page will break down your top talent in each core area of impact. These are strengths that you draw upon to deliver in each core area of impact. Based on your responses to the talent inventory the following strategies have been custom created for you, based on your leading talent for each core area...</p>
            </div>
            {dataForProfile && this.renderFooterForPage(6 + PAGE_OFFSET)}
          </div>
        </div>

        <div className="page report-export">
          <div className="report-play-to-your-strengths report-page">
            <img className="report-logo" width={LOGO_WIDTH} height={LOGO_HEIGHT} src={logo} />
            <h1>Play To Your Strengths<br/><small className="prepared-for" style={{textTransform: 'capitalize'}}>{dataForProfile.user.FirstName + ' ' + dataForProfile.user.LastName}</small></h1>

            {_.map(orderedTalentCategories, (talentCategory, index) => {
              return (
                <div key={'top-talent-definition-for-category-' + talentCategory.id} className={'report-section has-icon ' + (index === 3 ? 'no-bottom-border' : '')}>
                  <div className="section-icon">{iconForTalentCategory(talentCategory.id)}</div>
                  <div className="section-title">Top {talentCategory.name} Talent: {talentCategory.talents[0].name}</div>
                  <div className="section-content" dangerouslySetInnerHTML={{__html: descriptionForPlayToStrengthsTalent(talentCategory.talents[0].id)}}></div>
                </div>
              );
            })}
            {dataForProfile && this.renderFooterForPage(7 + PAGE_OFFSET)}
          </div>
        </div>
      </template>
    )
  }

  renderKnowYourStrengthsReport(dataForProfile){
    return (
      <div className="page report-export">
        <div className="report-know-your-strengths report-page">
          <img className="report-logo" width={LOGO_WIDTH} height={LOGO_HEIGHT} src={logo} />
          <h1>Know Your Strengths<br/><span className="prepared-for" style={{textTransform: 'capitalize'}}>{dataForProfile.user.FirstName + ' ' + dataForProfile.user.LastName}</span></h1>
          {dataForProfile && this.renderStrengthsScores()}
          {dataForProfile && this.renderTalentCategories()}
          {dataForProfile && this.renderFooterForPage(1 + PAGE_OFFSET)}
        </div>

        {dataForProfile && _.map(this.orderedTalentCategories(), this.renderCategoryPage.bind(this))}

        {!dataForProfile && this.renderLoadingMessage()}
      </div>
    )
  }

  render(){

    const dataForProfile = this.dataForProfile();

    console.log('main render');
    console.log('users: ', this.props.users);
    console.log('dataForProfile: ', dataForProfile);

    if(!dataForProfile || !dataForProfile.user){
      return null;
    }

    return (
      <div>
        {this.renderKnowYourStrengthsReport(dataForProfile)}
        {this.renderPlayToYourStrengthsReport(dataForProfile)}
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    users: state.users,
  }
}

export default connect(mapStateToProps, {})(WestinghouseReport);



// WEBPACK FOOTER //
// ./src/components/report_deprecated/westinghouse.js